import { useMemo } from 'react';
import {
  inputSheetAfterCellsChanged
} from 'pages/Waterfall/SpreadsheetConfig/InputSheetConfig/InputSheetRowConfig/inputSheetAfterCellsChanged';
import { buildTotalFundInvestmentsExpression } from 'pages/Waterfall/utilities';
import { UseCreateInputSheetProps } from './useCreateInputSheet.props';
import { SpreadsheetConfig } from '../../../../../components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import InputSheetParser from '../InputSheetParser/InputSheetParser';
import inputSheetRowConfig from '../InputSheetRowConfig/inputSheetRowConfig';

const useCreateInputSheet = ({
  exitDate,
  capTableId,
  equityValue,
  enterpriseValue,
  firmOptions,
  childrenCapTables,
  parentCapTables,
  fundInvestmentsSheetsNamesRef,
  plusCash,
  lessDebt,
}: UseCreateInputSheetProps) => {
  const exitProceedsExpression = buildTotalFundInvestmentsExpression(fundInvestmentsSheetsNamesRef.current);
  const inputSheetConfig = useMemo(() => {
    if (!exitDate) {
      return null; // Ensure all required fields are provided
    }
    return new SpreadsheetConfig({
      rowConfig: inputSheetRowConfig({
        exitDate,
        capTableId,
        equityValue,
        firmOptions,
        plusCash,
        lessDebt,
        enterpriseValue,
        childrenCapTables,
        parentCapTables,
        exitProceedsExpression,
      }),
      columns: [{}, {}],
      parser: InputSheetParser,
      afterCellChanged: inputSheetAfterCellsChanged,
      reverseParser: () => ({}) as unknown as SpreadsheetConfig['reverseParser'], // no reverse parsing needed for this page
      showTitlesColumn: false,
      colTitleRow: -1, // No title row
      name: 'InputSheet',
      tableTerms: {} as SpreadsheetConfig['tableTerms'],
    });
  }, [exitDate, capTableId, equityValue, firmOptions, plusCash, lessDebt, enterpriseValue, childrenCapTables, parentCapTables, exitProceedsExpression]);
  return inputSheetConfig;
};

export default useCreateInputSheet;
